export default __webpack_public_path__ + "static/media/klap-loader.6beb9097.svg";